
import { useEffect, useRef, useState } from 'react'

import { useDispatch } from 'react-redux'

import { getImageUrl } from '../../../utils/images'


export const SuccessActionModal = ({
  show,
  heading,
  btnText,
  subColoredHeading,
  subHeading,
  datedOn,
  type,
  action,
  submitText,
  Close,
  imgString
}) => {
  const dispatch = useDispatch()
  const modalRef = useRef()

  const [customDocName, setCustomDocName] = useState('')

  useEffect(() => {
    if (show) {
      document.getElementsByTagName('body')?.[0]?.classList.add('modal-open')
      setTimeout(() => {
        document.getElementById('success-action')?.classList.add('show')
      }, 100)
    } else {
      document.getElementsByTagName('body')?.[0]?.classList.remove('modal-open')
    }
  }, [show])

  useEffect(() => {
    const handler = event => {
      if (!modalRef.current) {
        return
      }
      if (modalRef.current == event.target) {
        Close()
      }
    }
    document.addEventListener('click', handler, true)
    return () => {
      document.removeEventListener('click', handler)
    }
  }, [])

  return show ? (
    <div>
      <div
        className='modal fade'
        id='success-action'
        aria-modal='true'
        role='dialog'
        style={{ display: 'block' }}
        ref={modalRef}
      >
        <div class="modal-dialog modal-dialog-centered modal-sm mw-400p">
    <div class="modal-content rounded-10 text-center">
      <div class="modal-body p-4">
      <img src={getImageUrl(imgString)} alt='img' class='mr-3' />
        <p class="mb-4 font-14 font-weight-700">{heading}</p>
        <p class="text-grey mb-30">{subHeading}<br />{datedOn}</p>
        <div class="px-4">
          <button type="button" onClick={action} class="btn btn-default btn-block">{btnText}</button>
        </div>
      </div>
    </div>
  </div>
      </div>
      <div className={`modal-backdrop fade ${show && 'show'}`} />
    </div>
  ) : (
    <div></div>
  )
}
